import { defineStore } from "pinia";

export const useLayoutStore = defineStore("layout", {
  state: () => ({
    layout: {
      topbar: {
        title: null,
        userIsInFlowScreen: false,
      },
    },
  }),
  actions: {
    async setGenerativeTopbarTitle(newTitle, delay = 50) {
      // Step 1: Clear the title directly
      if (this.layout.topbar.title) {
        this.layout.topbar.title = null;
        await new Promise((resolve) => setTimeout(resolve, delay));
      }

      // Step 2: Simulate typing effect to set the new title
      for (let i = 0; i <= newTitle.length; i++) {
        this.layout.topbar.title = newTitle.slice(0, i);
        await new Promise((resolve) => setTimeout(resolve, delay));
      }
    },
    setUserIsInFlowScreen(value) {
      this.layout.topbar.userIsInFlowScreen = value;
    },
    setTopbarTitle(title) {
      this.layout.topbar.title = title;
    },
    clearTopbarTitle() {
      this.layout.topbar.title = null;
    },
  },
  persist: {
    enabled: true,
    strategies: [
      {
        key: "layout",
        storage: localStorage,
      },
    ],
  },
});
